import {createAction} from '@reduxjs/toolkit'

import {FDSRejectionReasonType, FDSStatusType} from '@web/slices/fds/slice'

export type FDSFinishParam =
    | {
          status: Extract<FDSStatusType, 'PENDING' | 'FULFILLED'>
      }
    | {
          status: Extract<FDSStatusType, 'FAILED'>
          rejectionReason: Maybe<FDSRejectionReasonType>
      }

/** fds 진행상태를 종료로 세팅합니다 */
const finishFDS = createAction<FDSFinishParam>('processFds/finishFDS')

export default finishFDS
